// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Visa: React.FC = () => {
    return <svg width="40" height="24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><g fill="none" fillRule="evenodd" opacity=".9"><rect fill="#26337A" width="40" height="24" rx="4"/><path fill="#FFFFFE" d="M16.596 15.819l1.23-7.63h1.966l-1.23 7.63h-1.966M25.693 8.376a4.86 4.86 0 00-1.761-.32c-1.944 0-3.312 1.036-3.324 2.518-.012 1.097.977 1.708 1.722 2.073.766.374 1.023.613 1.02.947-.005.51-.611.745-1.176.745-.787 0-1.206-.115-1.852-.4l-.253-.122-.275 1.708c.459.213 1.308.397 2.19.407 2.066 0 3.408-1.023 3.424-2.606.007-.87-.517-1.529-1.651-2.073-.687-.354-1.109-.588-1.104-.947 0-.317.356-.656 1.126-.656a3.448 3.448 0 011.471.293l.177.087.266-1.654M28.31 13.114c.164-.439.784-2.133.784-2.133-.011.02.162-.442.261-.728l.133.658.455 2.203h-1.632zm2.426-4.917h-1.519c-.471 0-.824.135-1.03.632l-2.92 6.992h2.065s.337-.94.413-1.147l2.518.004c.06.267.24 1.143.24 1.143h1.824l-1.59-7.624zM14.947 8.195l-1.925 5.202-.206-1.057c-.358-1.219-1.474-2.539-2.723-3.2l1.76 6.672 2.081-.001 3.096-7.616h-2.083"/><path d="M11.236 8.19h-3.17l-.026.158c2.467.632 4.099 2.158 4.776 3.992l-.689-3.506c-.118-.483-.464-.627-.89-.644" fill="#EC982D"/></g></svg>;
};

export default React.memo(Visa);
